import React from "react";
import axios from "axios";
import {format} from "date-fns";
import {downloadBinaryResponse} from "@/shared/helpers";

// Import files are private: download through the authenticated API, never a public storage URL.
// The App.jsx interceptor resolves failed requests ({handled: true}) and has already shown the error.
const downloadImportFile = async (row) => {
  const response = await axios.post(
    `/organization/${row.organization_id}/import/${row.id}/file`,
    {},
    {responseType: "blob"}
  );
  const isRefusedDownload = response?.handled || response?.status !== 200;
  if (isRefusedDownload) return;
  await downloadBinaryResponse(response, row.name);
};

// Failures are already reported by the axios interceptor's flash; the catch only stops an unhandled rejection.
const ViewImportFile = ({row}) => (
  <a className="link" style={{cursor: "pointer"}} onClick={() => downloadImportFile(row).catch(() => {})}>view</a>
);

const RenderActions = ({row}) => {
  return (
      <span>
          <a className='link' style={{cursor: 'pointer'}}>View</a>
      </span>
  )
}

export const TABLE_COLUMNS = [
    {
      Header: "Import Date",
      accessor: "created_at",
      Cell: ({ row, value }) => { return format(new Date(value), "MM/dd/yyyy")}
    },
    {
      Header: "File Name",
      accessor: "name",
    },
    {
      Header: "Actions",
      accessor: "action",
      Cell: ({ row }) => row.original?.file_exists ? <ViewImportFile row={row.original}/> : 'file not found',
    }
    // {
    //   Header: "View",
    //   accessor: "name",
    // },
  // {
  //   Header: "Program Id",
  //   accessor: "program_id",
  // },
  // {
  //   Header: "Program Name",
  //   accessor: "program_name",
  // },
  // {
  //   Header: "External Id",
  //   accessor: "external_id",
  // },
  // {
  //   Header: "Org Id",
  //   accessor: "recipient_organization_uid",
  // },
  // {
  //   Header: "First Name",
  //   accessor: "recipient_first_name",
  // },
  // {
  //   Header: "Last Name",
  //   accessor: "recipient_last_name",
  // },
  // {
  //   Header: "Email",
  //   accessor: "recipient_email",
  // },
  // {
  //   Header: "Amount Awarded",
  //   accessor: "points_awarded",
  //   Cell: ({ row, value }) => { return toPoints(row.original.factor_valuation * value); },
  // },
  // {
  //   Header: "Amount Redeemed",
  //   accessor: "points_redeemed",
  //   Cell: ({ row, value }) => { return toPoints(row.original.factor_valuation * value); },
  // },
  // {
  //   Header: "Amount Expired",
  //   accessor: "points_expired",
  //   Cell: ({ row, value }) => { return toPoints(row.original.factor_valuation * value); },
  // },
  // {
  //   Header: "Amount Reclaimed",
  //   accessor: "points_reclaimed",
  //   Cell: ({ row, value }) => { return toPoints(row.original.factor_valuation * value); },
  // },
  // {
  //   Header: "Award Credit Reclaimed",
  //   accessor: "award_credit_points_reclaimed",
  //   Cell: ({ row, value }) => { return toPoints(row.original.factor_valuation * value); },
  // },
  // {
  //   Header: "Current Balance",
  //   accessor: "points_balance",
  //   Cell: ({ row, value }) => { return toPoints(row.original.factor_valuation * value); },
  // },
  // {
  //   Header: "Peer Points Allocated",
  //   accessor: "peer_rewards_earned",
  //   Cell: ({ row, value }) => { return toPoints(row.original.factor_valuation * value); },
  // },
  // {
  //   Header: "Peer Points Given",
  //   accessor: "peer_rewards_given",
  //   Cell: ({ row, value }) => { return toPoints(row.original.factor_valuation * value); },
  // },
  // {
  //   Header: "Peer Points Balance",
  //   accessor: "peer_balance",
  //   Cell: ({ row, value }) => { return toPoints(row.original.factor_valuation * value); },
  // },
  // {
  //   Header: "Anniversary",
  //   accessor: "anniversary",
  // },
  // {
  //   Header: "Birthday",
  //   accessor: "birth",
  // },
];
